@file:OptIn(ExperimentalMaterial3Api::class)

package us.laantech.laanmanage.feature.store.inventory

import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.lifecycle.viewmodel.initializer
import androidx.lifecycle.viewmodel.viewModelFactory
import us.laantech.common.ui.DataTableView
import us.laantech.common.util.toDollarStrFromCents
import us.laantech.common.util.tryFormatAsDateTime
import us.laantech.routes.pos.reports.z.DataTableRow


@Composable
fun InventoryManagementView(
    viewModel: InventoryManagementViewModel = viewModel(
        factory = viewModelFactory {
            initializer { InventoryManagementViewModel() }
        }
    )
) {
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    LaunchedEffect(Unit) {
        viewModel.loadProducts()
    }

    // TODO Low Stock Alert mode

    Column {
        Text("Inventory Management")

        // TODO filters, sort, etc.

        // TODO search


        InventoryStatsView(viewModel)


    }

    if (uiState.showInventoryHistoryModal) {
        InventoryHistoryModal(viewModel)
    }

}


@Composable
fun InventoryHistoryModal(viewModel: InventoryManagementViewModel) {

    val uiState by viewModel.uiState.collectAsStateWithLifecycle()

    BasicAlertDialog({
        viewModel.toggleInventoryHistoryModal(null)
    }) {
        Text("History")

        Surface(
            shape = MaterialTheme.shapes.large,
            tonalElevation = 6.dp
        ) {
            Column(modifier = Modifier.padding(16.dp)) {
                Text("History")

                val logs = uiState.selectedProduct?.inventoryLog.orEmpty()

                DataTableView(
//                    modifier = Modifier.fillMaxSize(),
                    rows = logs,
                ) {
                    val textAlign = TextAlign.Center

                    column("Date", weight = 2f) { row ->
                        Text(
                            row.createdAt?.tryFormatAsDateTime().toString(),
                            modifier = Modifier.weight(2f),
                            textAlign = TextAlign.Start
                        )
                    }
                    column("Added", weight = 1f) { row ->
                        Text(
                            row.addedCount.toString(),
                            modifier = Modifier.weight(1f),
                            textAlign = textAlign
                        )
                    }
                    column("Unit Cost", weight = 1.5f) { row ->
                        Text(
                            row.unitCostCents?.toDollarStrFromCents() ?: "-",
                            modifier = Modifier.weight(1.5f),
                            textAlign = TextAlign.End
                        )
                    }
                    column("Sold", weight = 1f) { row ->
                        Text(
                            row.soldCount.toString(),
                            modifier = Modifier.weight(1f),
                            textAlign = textAlign
                        )
                    }
                    column("Expired", weight = 1f) { row ->
                        Text(
                            row.expiredCount.toString(),
                            modifier = Modifier.weight(1f),
                            textAlign = textAlign
                        )
                    }
                    column("Damaged", weight = 1f) { row ->
                        Text(
                            row.damagedCount.toString(),
                            modifier = Modifier.weight(1f),
                            textAlign = textAlign
                        )
                    }
                    column("Write Off", weight = 1f) { row ->
                        Text(
                            row.writeOffCount.toString(),
                            modifier = Modifier.weight(1f),
                            textAlign = textAlign
                        )
                    }
                    column("Store Use", weight = 1f) { row ->
                        Text(
                            row.storeUseCount.toString(),
                            modifier = Modifier.weight(1f),
                            textAlign = textAlign
                        )
                    }
                    column("Lost", weight = 1f) { row ->
                        Text(
                            row.lostCount.toString(),
                            modifier = Modifier.weight(1f),
                            textAlign = textAlign
                        )
                    }
                    column("Total", weight = 1f) { row ->
                        Text(
                            row.total.toString(),
                            modifier = Modifier.weight(1f),
                            textAlign = textAlign
                        )
                    }
                }


            }
        }

    }

}





@Composable
fun InventoryStatsView(viewModel: InventoryManagementViewModel) {

    val uiState by viewModel.uiState.collectAsStateWithLifecycle()

    Column {

        DataTableView(
            modifier = Modifier.fillMaxSize(),
            rows = uiState.products,
        ) {
            column("Product Name", weight = 3f) { row ->
                Text(row.title ?: "No Title", modifier = Modifier.weight(3f))
            }
            column("Added", weight = 1f) { row ->
                Text("${row.inventory?.addedCount}", modifier = Modifier.weight(1f))
            }
            column("Sold", weight = 1f) { row ->
                Text("${row.inventory?.soldCount}", modifier = Modifier.weight(1f))
            }
            column("Write Off", weight = 1f) { row ->
                Text("${row.inventory?.writeOffCount}", modifier = Modifier.weight(1f))
            }
            column("Expired", weight = 1f) { row ->
                Text("${row.inventory?.expiredCount}", modifier = Modifier.weight(1f))
            }
            column("Store Use", weight = 1f) { row ->
                Text("${row.inventory?.storeUseCount}", modifier = Modifier.weight(1f))
            }
            column("Damaged", weight = 1f) { row ->
                Text("${row.inventory?.damagedCount}", modifier = Modifier.weight(1f))
            }
            column("Lost", weight = 1f) { row ->
                Text("${row.inventory?.lostCount}", modifier = Modifier.weight(1f))
            }
            column("Total Deducted", weight = 1f) { row ->
                Text("${row.getTotalInventoryOut()}", modifier = Modifier.weight(1f))
            }
            column("In Stock", weight = 1f) { row ->
                Text("${row.netInventory()}", modifier = Modifier.weight(1f))
            }
            column("Actions", weight = 2f) { row ->

                // TODO turn into adaptive button container
                BoxWithConstraints(modifier = Modifier.weight(2f)) {
                    if (maxWidth > 100.dp) {
                        Row {
                            Button(
                                onClick = { /* viewModel.openEditProductScreen(row) */ },
                                modifier = Modifier.weight(1f),
                                contentPadding = PaddingValues(0.dp),
                            ) {
                                Text("Update", fontSize = 12.sp)
                            }
                            Button(
                                onClick = { viewModel.toggleInventoryHistoryModal(row) },
                                modifier = Modifier.weight(1f),
                                contentPadding = PaddingValues(0.dp),
                            ) {
                                Text("History", fontSize = 12.sp)
                            }
                        }
                    } else {
                        Column {
                            Button(
                                onClick = { /* viewModel.openEditProductScreen(row) */ },
                                modifier = Modifier.fillMaxWidth(),
                                contentPadding = PaddingValues(0.dp),
                            ) {
                                Text("Update", fontSize = 12.sp)
                            }
                            Button(
                                onClick = { viewModel.toggleInventoryHistoryModal(row) },
                                modifier = Modifier.fillMaxWidth(),
                                contentPadding = PaddingValues(0.dp),
                            ) {
                                Text("History", fontSize = 12.sp)
                            }
                        }
                    }
                }


            }
        }
    }
}


